/**
 * How long a download's object URL outlives the click. Desktop browsers read
 * the blob at once, but iOS Safari first asks "Download report.pdf?" and only
 * reads it after the user taps Download, which can be many seconds later; a URL
 * revoked by then fails the download (WebKitBlobResource error 1). FileSaver.js
 * waits 40 s for the same reason. The cost is only that the blob's memory is
 * held a minute longer.
 */
export const OBJECT_URL_LIFETIME_MS = 60_000;
/** Trigger a browser download for a blob via a transient anchor element. */
export function saveBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_LIFETIME_MS);
}
